import { Link } from 'react-router-dom'
import { siteContent, socialLinks } from '../content/siteContent'
import { Logo } from './Logo'
import { SocialIcon } from './SocialIcon'

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container site-footer__grid">
        <div><Logo /></div>
        <div><h2>Kontakt</h2><a href={`mailto:${siteContent.email}`}>{siteContent.email}</a></div>
        <div><h2>Social media</h2><div className="social-links">{socialLinks.map((social) => <a key={social.label} href={social.href} target="_blank" rel="noreferrer" aria-label={social.label}><SocialIcon platform={social.platform} /></a>)}</div></div>
      </div>
      <div className="container site-footer__bottom">
        <p>© {new Date().getFullYear()} Katarzyna Staszewska</p>
        <Link to="/polityka-prywatnosci">Polityka prywatności</Link>
      </div>
    </footer>
  )
}
